<template>
  <div :class="[classes.container]">
    <div :class="[labelPosition === 'top' ? 'block' : 'flex items-center']">
      <!-- only show if label if set -->
      <div
        v-if="label"
        class="order-2 block text-xs font-semibold"
        :class="[disabled && 'text-ricoma-gray-600', labelPosition !== 'right' && 'mb-2']"
      >
        {{ label }}
      </div>

      <label v-if="isToggle" :class="[inputValue && 'checked']" class="mr-2 form-toggle-label">
        <input type="checkbox" class="form-toggle-input" v-model="inputValue" />
      </label>

      <div v-else class="mr-2 form-checkbox">
        <input
          class="form-checkbox-input"
          type="checkbox"
          :id="`checkbox-${checkboxId}`"
          v-model="inputValue"
          :disabled="disabled"
        />
        <label
          class="form-checkbox-label"
          :class="[disabled && 'disabled']"
          :for="`checkbox-${checkboxId}`"
        ></label>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'VFormCheckbox',
  data() {
    return {
      inputValue: false,
    };
  },
  props: {
    label: {
      type: String,
      required: false,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'top',
    },
    initialValue: {
      type: [Boolean, Number],
      required: false,
      default: false,
    },
    isToggle: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: [String, Object],
      required: false,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    checkboxId() {
      return uuidv4();
    },
  },
  watch: {
    inputValue(val) {
      this.$emit('update', val);
    },
    initialValue(val) {
      this.inputValue = val;
    },
  },
  mounted() {
    // ensure that input values is always updated with the initial value
    this.inputValue = this.initialValue;
  },
};
</script>

<style lang="postcss">
.form {
  &-checkbox-input,
  &-toggle-input {
    @apply hidden;
  }

  /* checkbox styles */
  &-checkbox {
    &-label {
      @apply flex items-center justify-center w-6 h-6 border rounded cursor-pointer border-ricoma-gray-800;

      &::before {
        content: '\2713';
        @apply hidden;
      }
    }

    &-label.disabled {
      @apply border-ricoma-gray-300 bg-ricoma-gray-100;
    }

    &-input:checked + label.disabled {
      @apply bg-ricoma-gray-500;
    }

    &-input:checked + label {
      @apply bg-ricoma-gray-800;
    }

    &-input:checked + label::before {
      @apply inline-block text-white text-sm font-semibold;
    }
  }

  /* toggle styles */
  &-toggle {
    &-label {
      @apply block w-16 h-10 border border-black rounded-full bg-ricoma-gray-200 relative flex items-center px-1 cursor-pointer;

      &::before {
        content: '';
        @apply block h-full w-8 h-8 bg-white rounded-full shadow-sm;
      }
    }

    &-label.checked {
      @apply justify-end bg-green-400;
    }
  }
}
</style>
